/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtCloseConfig = {
  /** Config pubkey */
  config: Address;
  /** admin pk */
  admin: Address;
};

export type EvtCloseConfigArgs = EvtCloseConfig;

export function getEvtCloseConfigEncoder(): FixedSizeEncoder<EvtCloseConfigArgs> {
  return getStructEncoder([
    ["config", getAddressEncoder()],
    ["admin", getAddressEncoder()],
  ]);
}

export function getEvtCloseConfigDecoder(): FixedSizeDecoder<EvtCloseConfig> {
  return getStructDecoder([
    ["config", getAddressDecoder()],
    ["admin", getAddressDecoder()],
  ]);
}

export function getEvtCloseConfigCodec(): FixedSizeCodec<
  EvtCloseConfigArgs,
  EvtCloseConfig
> {
  return combineCodec(getEvtCloseConfigEncoder(), getEvtCloseConfigDecoder());
}
